module.exports = __webpack_public_path__ + "static/media/bg_siaf_opacity.07f00dbb.png";